/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_No_MatchInputs */

const en_task_requested_documents_no_match = /** @type {(inputs: Task_Requested_Documents_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching document type.`)
};

const pt_br2_task_requested_documents_no_match = /** @type {(inputs: Task_Requested_Documents_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum tipo de documento correspondente.`)
};

/**
* | output |
* | --- |
* | "No matching document type." |
*
* @param {Task_Requested_Documents_No_MatchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_no_match = /** @type {((inputs?: Task_Requested_Documents_No_MatchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_No_MatchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_no_match(inputs)
	return pt_br2_task_requested_documents_no_match(inputs)
});